import type { NavigationTab } from '@swf/poker';

import FlashAnimation from '../assets/animations/flash-tab.json';
import HoldemAnimation from '../assets/animations/holdem-tab.json';
import MaxAnimation from '../assets/animations/max-tab.json';
import OmahaAnimation from '../assets/animations/omaha-tab.json';
import styles from '../styles/shared.scss';
import type { GameTypeName } from '../types/Game';
import { GAME_TYPE_URL_MAP, GameType } from '../types/Game';

import {
  TXTCLI_FLASH,
  TXTCLI_Flash_HoldXem,
  TXTCLI_HoldXem,
  TXTCLI_Max,
  TXTCLI_Max_HoldXem,
  TXTCLI_Omaha
} from './index.messages.json';

export const ENDPOINTS = {
  spinData: '/api/v1-preview/sag/spindata',
  spinDataSubscription: '/api/v1-preview/stream/sag/spindata',
  prizeDistribution: '/api/v1-preview/sag/prizes',
  watchGamesSubscription: '/api/v1-preview/stream/sag/watchgames',
  avatarImages: '/api/v1-preview/sag/dbmimages',
  tileBackground: '/api/v1-preview/sag/image'
};

export const NAVIGATION_DATA: Record<string, NavigationTab<GameTypeName>> = {
  Holdem: {
    title: TXTCLI_HoldXem,
    shortTitle: TXTCLI_HoldXem,
    tabActiveStyle: styles.tabActiveHoldem,
    tabName: GameType.Holdem,
    animation: HoldemAnimation,
    alias: 'pokerSpinAndGo',
    routeValues: {
      tab: GAME_TYPE_URL_MAP.Holdem
    }
  },
  HoldemFlash: {
    title: TXTCLI_Flash_HoldXem,
    shortTitle: TXTCLI_FLASH,
    tabActiveStyle: styles.tabActiveHoldemFlash,
    tabName: GameType.HoldemFlash,
    animation: FlashAnimation,
    animationStyle: 'flashAnimation',
    alias: 'pokerSpinAndGo',
    routeValues: {
      tab: GAME_TYPE_URL_MAP.HoldemFlash
    }
  },
  HoldemMax: {
    title: TXTCLI_Max_HoldXem,
    shortTitle: TXTCLI_Max,
    tabActiveStyle: styles.tabActiveHoldemMax,
    tabName: GameType.HoldemMax,
    animation: MaxAnimation,
    alias: 'pokerSpinAndGo',
    routeValues: {
      tab: GAME_TYPE_URL_MAP.HoldemMax
    }
  },
  Omaha: {
    title: TXTCLI_Omaha,
    shortTitle: TXTCLI_Omaha,
    tabActiveStyle: styles.tabActiveOmaha,
    tabName: GameType.Omaha,
    animation: OmahaAnimation,
    alias: 'pokerSpinAndGo',
    routeValues: {
      tab: GAME_TYPE_URL_MAP.Omaha
    }
  }
};
